export const isDarkMode = (state) => state.settings.darkMode;
